export default {
  getHead: () => {
    return [
      {name: '종류', style: {width: '120px'}},
      {name: '제목', style: {width: '240px'}},
      {name: '팝업 노출 여부', style: {width: '260px', minWidth: '260px!important'}},
      {name: '작성자', style: {width: '120px'}},
      {name: '등록일', style: {width: '120px'}},
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).noticeName // 종류
      case 1: return func.getContent(value).title // 제목
      case 2: {
        if (func.getContent(value).open) {
          const beginDate = func.getContent(value).options.beginDate
          const endDate = func.getContent(value).options.endDate
          const skipDate = func.getContent(value).options.skipDate

          let html = '<div style="display: grid; grid-template-columns: 56px 1fr; row-gap: 0.3rem; column-gap: 0.5rem">'
          html += '<div style="grid-row:1/3; grid-column: 1/2; display: flex; align-items: center;"><span style="padding: 0.5rem 1rem; border-radius: 8px; background: #7E72F2; color: #fff;">팝업</span></div>'
          if (beginDate || endDate) {
            html += `<span style="grid-column: 2/3">${beginDate} ~ ${endDate}</span>`
          }
          if (`${skipDate}` === '1') {
            html += '<span style="grid-column: 2/3">오늘 하루 보지 않기</span>'
          }
          else if (`${skipDate}` === '7') {
            html += '<span style="grid-column: 2/3">7일간 하루 보지 않기</span>'
          }
          html += '</div>'
          return {
            type: 'html',
            html
          }
        } else {
          return '-'
        }
      }
      case 3: return func.getContent(value).writer // 작성자
      case 4: return func.getCreatedDate(value.created_at) // 등록일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  // getSearchKeyValue: (nav) => {
  //   if (nav.value.created_at) {
  //     nav.dateTarget = 'created_at'
  //     nav.dateBegin = 'nav.value.created_at.sDate'
  //     nav.dateEnd = 'nav.value.created_at.eDate'
  //   }
  //   return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  // },
  getSearchKeyValue: (nav) => {
    nav.conditions = []

    if (nav.value.searchKeyword) {
      if (nav.value.searchType === '제목') {
        nav.conditions.push({
          key: 'body.title',
          operator: 'LIKE',
          value: `%${nav.value.searchKeyword}%`
        })
      } else if (nav.value.searchType === '작성자') {
        nav.conditions.push({
          key: 'body.writer',
          operator: 'LIKE',
          value: `%${nav.value.searchKeyword}%`
        })
      }
    }

    if (nav.value.created_at) {
      const beginDate = nav.value.created_at.sDate
      const endDate = nav.value.created_at.eDate
      if (endDate) {
        nav.conditions.push({
          key: 'body.options.beginDate', // post beginDate
          operator: '<=',
          value: endDate
        })
      }

      if (beginDate) {
        nav.conditions.push({
          key: 'body.options.endDate', // post endDate
          operator: '>=',
          value: beginDate
        })
      }
    }



    return { conditions: nav.conditions };
  },

  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
      case '제목': returnData.push('content$body.title*%[:default_skw]%'); break
      case '작성자': returnData.push('content$body.writer*%[:default_skw]%'); break
    }

    return returnData
  },
}
